export const APP_THEMES = [
	{
		id: 'catpuccin',
		label: 'Catpuccin',
		className: 'theme-catpuccin',
	},
	{
		id: 'iuspro',
		label: 'IUS PRO',
		className: '',
	},
] as const

export type AppThemeId = (typeof APP_THEMES)[number]['id']

export const ACTIVE_APP_THEME_ID = 'iuspro' satisfies AppThemeId

export function getAppTheme(themeId: AppThemeId) {
	const theme = APP_THEMES.find(item => item.id === themeId)
	if (!theme) {
		throw new Error(`Unknown app theme: ${themeId}`)
	}
	return theme
}

export const ACTIVE_APP_THEME = getAppTheme(ACTIVE_APP_THEME_ID)
